import { useDispatch, useSelector } from "react-redux"
import { ItemList } from "./ItemList";
import { ItemAdd } from "./ItemAdd";
import { carritoStartLoadingAction, startItemAddNewAction } from "../../actions/carritoActions";
import { useEffect, useState } from "react";
import { SummaryCart } from "./SummaryCart";



export const CarritoApp = () => {

  const dispatch = useDispatch();

  const { carritoItems } = useSelector( state => state.carrito);
   const [total, setTotal] = useState(0);

  useEffect(() => {

    // Guardamos en el localStorage los items del carrito para hacerlo percistente
    localStorage.setItem('items', JSON.stringify( carritoItems ) ); 


    // localStorage.setItem('items', JSON.stringify( removeArrayDuplicates(carritoItems, "codigo") ) ); // Simplificamos los items repetidos del carrito items

    let reduce = carritoItems.reduce((acumulador, actual) => acumulador + parseFloat(actual.costo), 0); //Sumamos los costos de los items
    setTotal( reduce.toFixed(2) );
    console.log(reduce.toFixed(2));
  }, [carritoItems]);
  
  useEffect( () => {
      dispatch( carritoStartLoadingAction() );
    }, [dispatch]);

  const handleNewItem = ( item ) => {
    console.log({ item });

    dispatch( startItemAddNewAction( item ));
  }

  return (
    <>
    
      {/* <h1>Carrito App</h1> */}
      <div className="col-lg-12">
        <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="mb-0">Shopping Cart</h4>
              <span className="text-muted">{ carritoItems.length } items</span>
          </div>
      </div>

        <ItemAdd onNewItem={ handleNewItem } />

      <hr/>

      <div className="row">
       
          <ItemList carritoItems={ carritoItems } />
       
          <SummaryCart total={ total } />

        <div className="col-5">

        </div>
      </div>


    </>
  )
}
